const BLOCK = 'youtube-player';

const SEL = {
    player:      `.${BLOCK}`,
    facade:      `.${BLOCK}__facade`,
    iframeClass: `${BLOCK}__iframe`,
} as const;

function activatePlayer(facade: HTMLButtonElement): void {
    const player  = facade.closest<HTMLElement>(SEL.player);
    const wrapper = facade.parentElement;
    if (!player || !wrapper) return;

    const embedUrl = player.dataset.embedUrl;
    if (!embedUrl) return;

    const iframe = document.createElement('iframe');
    iframe.src           = `${embedUrl}?autoplay=1&rel=0`;
    iframe.className     = SEL.iframeClass;
    iframe.title         = facade.getAttribute('aria-label') ?? 'YouTube Video';
    iframe.allow         = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation allow-popups');

    wrapper.replaceChildren(iframe);
}

function bindFacade(facade: HTMLButtonElement): void {
    facade.addEventListener('click', () => activatePlayer(facade), { once: true });
}

export function initYouTubePlayer(): void {
    document.querySelectorAll<HTMLButtonElement>(SEL.facade).forEach(bindFacade);

    if (!document.body.classList.contains('neos-backend')) return;

    new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (!(node instanceof HTMLElement)) continue;
                if (node.matches(SEL.facade)) bindFacade(node as HTMLButtonElement);
                node.querySelectorAll<HTMLButtonElement>(SEL.facade).forEach(bindFacade);
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
}
